module.exports = __webpack_public_path__ + "img/Asset 13@4x.e4fb0e76.png";